import { render, staticRenderFns } from "./ExpiredIDCards.vue?vue&type=template&id=088fbe56&scoped=true&"
import script from "./ExpiredIDCards.vue?vue&type=script&lang=js&"
export * from "./ExpiredIDCards.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredIDCards.vue?vue&type=style&index=0&id=088fbe56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088fbe56",
  null
  
)

export default component.exports